import { createSlice, current } from '@reduxjs/toolkit';
import ApiClient, { createFetchErrorMessage } from '../../../utils/api/ApiClient';


const initialState = { loading:true, list:[], page:0, pageCount:1, totalElements:0, message:null };
const wishBooksSlice = createSlice({
    name: 'wishBooks',
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
            state.message = null;
        },
        fetch: (state, action) => {
            state.loading = false;
            state.list = action.payload.list;
            state.page = action.payload.page;
            state.totalCount = action.payload.totalCount;
            state.totalElements = action.payload.totalCount;
        },
        delete: (state, action) => {
            let tempList = current(state.list).filter(item=>item.isbn!==action.payload);
            state.list = tempList;
        }
    }
});


export default wishBooksSlice.reducer;
export const wishBooksActions = wishBooksSlice.actions;


export const fetchWishBooks = (page = 0) => {

    return (dispatch) => {
        dispatch( wishBooksActions.loading() );

        const { promise } = ApiClient({
            url: `/api/book/wish/list?page=${page}`,
            data: { school_code: window.schoolCode },
            authToken: sessionStorage.getItem("user"),
        });

        promise.then((res) => {
            dispatch( wishBooksActions.fetch(res.data) );
        }).catch((err) => {
            const errorData = createFetchErrorMessage(err);
            console.log(errorData.message);
        })
    };

};


export const deleteBookKeep = (isbn) => {

    return (dispatch) => {
        const { promise } = ApiClient({
            url: `/api/book/keep/toggle/${isbn}`,
            authToken: sessionStorage.getItem("user"),
        });

        promise.then((res) => {
            dispatch( wishBooksActions.delete(isbn) );
        }).catch((err) => {
            const errorData = createFetchErrorMessage(err);
            console.log(errorData.message);
        })
    };

};